module.exports = __webpack_public_path__ + "media/bellanova_promo.3caa0210.mp4";